import React, { useState, useRef, useEffect } from "react";
import TextFieldGroup from "../../commons/TextFieldGroup";
import Searchbar from "../../commons/Searchbar";
import qs from "qs";

import computeItemDetails from "../../utils/computeItemDetails";
import {
  Layout,
  Breadcrumb,
  Form,
  Table,
  Divider,
  message,
  Input,
  Col,
  Row,
  Collapse,
  PageHeader,
  Button,
} from "antd";

import {
  formItemLayout,
  smallFormItemLayout,
  tailFormItemLayout,
} from "./../../utils/Layouts";
import { EditOutlined, CloseOutlined, DeleteOutlined } from "@ant-design/icons";
import isEmpty from "../../validation/is-empty";
import { useSelector } from "react-redux";
import {
  edit,
  onDelete,
  onSubmit,
  onSearch,
  onDeleteItem,
  onChange,
  onUpdateStatus,
  hasAccess,
} from "../../utils/form_utilities";
import moment from "moment";
import SelectFieldGroup from "../../commons/SelectFieldGroup";
import SupplierFormModal from "../modals/SupplierFormModal";
import {
  onSupplierSearch,
  onStockSearch,
  addKeysToArray,
  onWarehouseSearch,
  onBranchSearch,
} from "../../utils/utilities";
import DatePickerFieldGroup from "../../commons/DatePickerFieldGroup";
import TextAreaGroup from "../../commons/TextAreaGroup";
import numberFormat from "../../utils/numberFormat";
import round from "../../utils/round";
import axios from "axios";
import { sumBy, uniq } from "lodash";
import WarehouseFormModal from "../modals/WarehouseFormModal";
import { Link, useMatch, useNavigate, useParams } from "react-router-dom";
import numberFormatInt from "../../utils/numberFormatInt";
import SelectTagFieldGroup from "../../commons/SelectTagsFieldGroup";
import validator from "validator";
import FormButtons from "../../commons/FormButtons";
import classNames from "classnames";
import {
  ACCESS_ADD,
  ACCESS_ADVANCE_SEARCH,
  ACCESS_OPEN,
  CANCELLED,
  OPEN,
  STATUS_CLOSED,
} from "../../utils/constants";
import RangeDatePickerFieldGroup from "../../commons/RangeDatePickerFieldGroup";
import SimpleSelectFieldGroup from "../../commons/SimpleSelectFieldGroup";
import AccountFormModal from "../modals/AccountFormModal";
const { Content } = Layout;
const { Panel } = Collapse;
const transaction = "stocks-receiving";
const url = `/api/${transaction}/`;
const title = "Warehouse Receipt";

const initialItemValues = {
  stock: null,
  case_quantity: null,
  quantity: null,
  case_price: null,
  price: null,
  amount: null,
};

const transaction_counter = {
  label: "WR #",
  key: "rr_no",
};

const date_fields = ["date"];

const onGenerateStockRelease = ({
  state,
  user,
  history,
  setProcessing,
  processing,
}) => {
  if (processing) return;

  const form_data = {
    _id: state._id,
    user,
  };

  const loading = message.loading("Processing....");
  setProcessing(true);
  axios
    .put(`${url}stock-releasing`, form_data)
    .then((response) => {
      setProcessing(false);
      loading();
      navigate(`/stock-releasing/${response.data._id}`);
    })
    .catch((err) => {
      loading();
      setProcessing(false);
      message.error("There was an error processing your request");
    });
};

export default function StocksReceiving({}) {
  const params = useParams();
  const [errors, setErrors] = useState({});
  const [records, setRecords] = useState([]);
  const [processing, setProcessing] = useState(false);
  const [total_records, setTotalRecords] = useState(null);
  const [current_page, setCurrentPage] = useState(1);
  const [search_keyword, setSearchKeyword] = useState("");
  const auth = useSelector((state) => state.auth);
  const [item, setItem] = useState(initialItemValues);
  const [dr_numbers, setDrNumbers] = useState([]);
  const [options, setOptions] = useState({
    suppliers: [],
    stocks: [],
    purchase_orders: [],
    warehouses: [],
  });

  const [page_size, setPageSize] = useState(100);

  const [loading_state, setLoadingState] = useState({});

  const [loading, setLoading] = useState(false);
  const accountFormModal = useRef(null);
  const warehouseFormModal = useRef(null);
  const caseQuantityField = useRef(null);
  const quanttiyField = useRef(null);
  const casePriceField = useRef(null);
  const priceField = useRef(null);
  const amountField = useRef(null);
  const addItemButton = useRef(null);
  const stockField = useRef(null);

  const navigate = useNavigate();
  const [search_state, setSearchState] = useState({});

  const initialValues = {
    _id: null,
    rr_no: null,
    date: moment(),
    supplier: null,
    warehouse: auth.user?.warehouse,
    remarks: "",
    items: [],
    discounts: [],
    account: {},
    project: {},

    purchase_order: null,
    stock_release: null,
    sales_return: null,
    customer: null,

    gross_amount: 0,
    total_discount_amount: 0,
    total_amount: 0,
  };
  const [state, setState] = useState(initialValues);

  const records_column = [
    {
      title: "WR #",
      dataIndex: "rr_no",
    },
    {
      title: "PO #",
      dataIndex: ["purchase_order", "po_no"],
    },
    {
      title: "Date",
      dataIndex: "date",
      render: (date) => moment(date).format("MM/DD/YYYY"),
    },
    {
      title: "Warehouse",
      dataIndex: ["warehouse", "name"],
    },
    // {
    //   title: "Branch",
    //   dataIndex: "branch",
    //   render: (branch) => `${branch?.company?.name}-${branch?.name}`,
    // },
    {
      title: "Account",
      dataIndex: ["account", "name"],
    },
    /*{
      title: "PO#",
      dataIndex: ["purchase_order", "po_no"],
    },
    {
      title: "Supplier",
      dataIndex: ["supplier"],
      render: (value, record) => (
        <span>
          {record.customer?.name}
          {record.supplier?.name}
        </span>
      ),
    }, */
    /* {
      title: "Remarks",
      dataIndex: "remarks",
    }, */

    {
      title: "Reference",
      dataIndex: ["reference"],
    },
    {
      title: "Items",
      dataIndex: "items",
      width: 350,
      render: (items) =>
        (items || [])
          .slice(0, 4)
          .map((o) => o?.stock?.name)
          .join("/ "),
    },

    {
      title: "Total Amount",
      dataIndex: ["total_amount"],
      align: "right",
      render: (value) => numberFormat(value),
    },

    {
      title: "Status",
      dataIndex: ["status"],
      align: "center",
      render: (status, record, index) => {
        return (
          <span
            className={classNames("has-text-weight-bold", {
              "has-text-danger": status?.approval_status === CANCELLED,
            })}
          >
            {status?.approval_status || ""}
          </span>
        );
      },
    },
  ];

  const items_column = [
    /* {
      title: "",
      key: "action",
      width: 30,
      align: "center",
      render: (text, record, index) => (
        <span>
          {record.footer !== 1 &&
            [undefined, OPEN].includes(state.status?.approval_status) && (
              <span
                onClick={() => {
                  setState((prevState) => {
                    const items = [...prevState.items];

                    items.splice(index + 1, 0, {
                      ...initialItemValues,
                    });

                    return {
                      ...prevState,
                      items,
                    };
                  });
                }}
              >
                <i className="fas fa-plus"></i>
              </span>
            )}
        </span>
      ),
    }, */
    {
      title: "Item",
      dataIndex: ["stock", "name"],
    },

    {
      title: "Qty",
      dataIndex: "quantity",
      align: "right",
      width: 200,
      render: (value, record, index) => (
        <span>
          {record.footer !== 1 &&
          [undefined, OPEN].includes(state.status?.approval_status) ? (
            <Row gutter={8}>
              <Col span={24}>
                <input
                  type="number"
                  step={0.01}
                  className="has-text-right input-value"
                  value={record.quantity}
                  onChange={(e) => {
                    const value = e.target.value;
                    setState((prevState) => {
                      let items = [...state.items];

                      items[index] = {
                        ...items[index],
                        ...computeItemDetails({
                          ...items[index],
                          quantity: value,
                        }),
                      };

                      // if (items.length - 1 === index) {
                      //   items.push({
                      //     ...initialItemValues,
                      //   });
                      // }

                      return {
                        ...prevState,
                        items,
                      };
                    });
                  }}
                  align="right"
                />
              </Col>
            </Row>
          ) : (
            `${numberFormat(record.quantity)}`
          )}
        </span>
      ),
    },
    {
      title: "Unit",
      dataIndex: ["stock", "unit_of_measure"],
      align: "center",
      width: 100,
    },
    {
      title: "Unit Cost",
      dataIndex: "Price",
      align: "right",
      width: 200,
      render: (value, record, index) => (
        <span>
          {record.footer !== 1 &&
          [undefined, OPEN].includes(state.status?.approval_status) ? (
            <Row gutter={8}>
              <Col span={24}>
                <input
                  type="number"
                  step={0.01}
                  className="has-text-right input-value"
                  value={record.price}
                  onChange={(e) => {
                    const value = e.target.value;
                    setState((prevState) => {
                      let items = [...state.items];

                      items[index] = {
                        ...items[index],
                        ...computeItemDetails({
                          ...items[index],
                          price: value,
                        }),
                      };

                      // if (items.length - 1 === index) {
                      //   items.push({
                      //     ...initialItemValues,
                      //   });
                      // }

                      return {
                        ...prevState,
                        items,
                      };
                    });
                  }}
                  align="right"
                />
              </Col>
            </Row>
          ) : (
            numberFormat(record.price)
          )}
        </span>
      ),
    },
    {
      title: "Amount",
      dataIndex: ["amount"],
      align: "right",
      width: 100,
      render: (value, record, index) => (
        <span>
          {record.footer !== 1 &&
          [undefined, OPEN].includes(state.status?.approval_status) ? (
            <Row gutter={8}>
              <Col span={24}>
                <input
                  type="number"
                  step={0.01}
                  className="has-text-right input-value"
                  value={record.amount}
                  onChange={(e) => {
                    const value = e.target.value;
                    setState((prevState) => {
                      let items = [...state.items];
                      let { quantity, price } = items[index];

                      if (quantity) price = round(parseFloat(value) / quantity);

                      items[index] = {
                        ...items[index],
                        amount: parseFloat(value),
                        price,
                      };

                      if (items.length - 1 === index) {
                        items.push({
                          ...initialItemValues,
                        });
                      }

                      return {
                        ...prevState,
                        items,
                      };
                    });
                  }}
                  align="right"
                />
              </Col>
            </Row>
          ) : (
            `${numberFormat(record.amount)}`
          )}
        </span>
      ),
    },
    {
      title: "",
      key: "action",
      width: 80,
      align: "center",
      render: (text, record, index) => (
        <span>
          {record.footer !== 1 &&
            [undefined, OPEN].includes(state.status?.approval_status) && (
              <span
                onClick={() =>
                  onDeleteItem({
                    field: "items",
                    index,
                    setState,
                  })
                }
              >
                <i className="fas fa-trash-alt"></i>
              </span>
            )}
        </span>
      ),
    },
  ];

  useEffect(() => {
    const query = qs.parse(location.search, { ignoreQueryPrefix: true });

    const { _id } = query;

    (async () => {
      if (_id) {
        return edit({
          record: {
            _id,
          },
          setState,
          setErrors,
          setRecords,
          url,
          date_fields,
        });
      }
    })();

    return () => {};
  }, []);

  useEffect(() => {
    setState((prevState) => {
      const total_amount = sumBy(state.items, (o) => o.amount);
      const gross_amount = total_amount;
      let net_amount = gross_amount;

      (state.discounts || []).forEach((discount) => {
        let discount_rate = validator.isNumeric(discount.toString())
          ? 1 - round(discount) / 100
          : 1;

        net_amount = net_amount * discount_rate;
      });

      const total_discount_amount = round(gross_amount - net_amount);

      return {
        ...prevState,
        total_amount,
        gross_amount,
        total_discount_amount,
      };
    });

    return () => {};
  }, [state.items, state.discounts]);

  useEffect(() => {
    if (params?.id) {
      edit({
        record: {
          _id: params.id,
        },
        setState,
        setErrors,
        setRecords,
        url,
        date_fields,
      });
    }
    return () => {};
  }, []);

  useEffect(() => {
    const amount = round(
      round(round(item.case_quantity) * round(item.case_price)) +
        round(round(item.quantity) * round(item.price))
    );

    setItem((prevState) => {
      return {
        ...prevState,
        amount,
      };
    });

    return () => {};
  }, [item.case_quantity, item.quantity, item.case_price, item.price]);

  const can_edit = [OPEN, null, undefined].includes(
    state.status?.approval_status
  );

  return (
    <Content className="content-padding">
      <WarehouseFormModal
        setField={(warehouse) => {
          setState((prevState) => ({
            ...prevState,
            warehouse,
          }));
        }}
        ref={warehouseFormModal}
      />
      <AccountFormModal
        setField={(account) => {
          setState((prevState) => ({
            ...prevState,
            account,
          }));
        }}
        ref={accountFormModal}
      />
      <div className="columns is-marginless">
        <div className="column">
          <Breadcrumb style={{ margin: "16px 0" }}>
            <Breadcrumb.Item>Home</Breadcrumb.Item>
            <Breadcrumb.Item className="text-color-yellow">
              {title}
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <div className="column">
          <Searchbar
            name="search_keyword"
            onChange={(e) => setSearchKeyword(e.target.value)}
            value={search_keyword}
            onNew={
              hasAccess({
                auth,
                access: ACCESS_ADD,
                location,
              })
                ? () => {
                    setState({
                      ...initialValues,
                      date: moment(),
                      branch: auth.user?.branches?.[0] || null,
                    });
                    setItem(initialItemValues);
                    setRecords([]);
                  }
                : null
            }
          />
        </div>
      </div>

      {hasAccess({
        auth,
        access: ACCESS_ADVANCE_SEARCH,
        location,
      }) && (
        <Row>
          <Col span={24} className="m-b-1">
            <Collapse>
              <Panel header="Advance Search" key="1">
                <PageHeader
                  backIcon={false}
                  style={{
                    border: "1px solid rgb(235, 237, 240)",
                  }}
                  onBack={() => null}
                  title="Advance Filter"
                  subTitle="Enter appropriate data to filter records"
                >
                  <div className="or-slip-form">
                    <Row>
                      <Col span={8}>
                        <RangeDatePickerFieldGroup
                          label="Date"
                          name="period_covered"
                          value={search_state.period_covered}
                          onChange={(dates) =>
                            setSearchState((prevState) => ({
                              ...prevState,
                              period_covered: dates,
                            }))
                          }
                          formItemLayout={smallFormItemLayout}
                        />
                      </Col>
                      <Col span={8}>
                        <TextFieldGroup
                          label="WR #"
                          name="rr_no"
                          formItemLayout={smallFormItemLayout}
                          value={search_state[transaction_counter.key]}
                          onChange={(e) => {
                            onChange({
                              key: e.target.name,
                              value: e.target.value,
                              setState: setSearchState,
                            });
                          }}
                        />
                      </Col>
                      <Col span={8}>
                        <SelectFieldGroup
                          label="Account"
                          value={search_state.account?.name}
                          onFocus={() => {
                            onSupplierSearch({ value: "", setOptions });
                          }}
                          onSearch={(value) =>
                            onSupplierSearch({ value, setOptions })
                          }
                          onChange={(index) => {
                            const account = options.accounts?.[index] || null;
                            setSearchState((prevState) => ({
                              ...prevState,
                              account,
                            }));
                          }}
                          formItemLayout={smallFormItemLayout}
                          data={options.accounts}
                          column="name"
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col span={8}>
                        <SimpleSelectFieldGroup
                          label="Status"
                          name="approval_status"
                          value={search_state.approval_status}
                          onChange={(value) => {
                            onChange({
                              key: "approval_status",
                              value: value,
                              setState: setSearchState,
                            });
                          }}
                          error={errors?.approval_status}
                          formItemLayout={smallFormItemLayout}
                          options={[OPEN, STATUS_CLOSED, CANCELLED] || []}
                        />
                      </Col>
                      <Col span={8}>
                        <SelectFieldGroup
                          label="Item"
                          value={search_state.stock?.name}
                          onSearch={(value) =>
                            onStockSearch({ value, options, setOptions })
                          }
                          onChange={(index) => {
                            const stock = options.stocks[index];
                            setSearchState((prevState) => ({
                              ...prevState,
                              stock,
                            }));
                          }}
                          formItemLayout={smallFormItemLayout}
                          data={options.stocks}
                          column="display_name"
                        />
                      </Col>
                      <Col span={8}>
                        <TextFieldGroup
                          label="Reference"
                          name="reference"
                          formItemLayout={smallFormItemLayout}
                          value={search_state.reference}
                          onChange={(e) => {
                            onChange({
                              key: e.target.name,
                              value: e.target.value,
                              setState: setSearchState,
                            });
                          }}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col span={8}>
                        <SelectFieldGroup
                          label="Warehouse"
                          value={search_state.warehouse?.name}
                          onFocus={() => {
                            onWarehouseSearch({ value: "", setOptions });
                          }}
                          onSearch={(value) =>
                            onWarehouseSearch({ value, setOptions })
                          }
                          onChange={(index) => {
                            const warehouse =
                              options.warehouses?.[index] || null;
                            onChange({
                              key: "warehouse",
                              value: warehouse,
                              setState: setSearchState,
                            });
                          }}
                          formItemLayout={smallFormItemLayout}
                          data={options.warehouses}
                          column="name"
                          error={errors.warehouse}
                        />
                      </Col>
                      <Col span={8}>
                        <TextFieldGroup
                          label="PO #"
                          name="po_no"
                          formItemLayout={smallFormItemLayout}
                          value={search_state.po_no}
                          onChange={(e) => {
                            onChange({
                              key: e.target.name,
                              value: e.target.value,
                              setState: setSearchState,
                            });
                          }}
                        />
                      </Col>
                    </Row>

                    <Row>
                      <Col span={8}>
                        <Row>
                          <Col offset={8} span={12}>
                            <Button
                              type="info"
                              size="large"
                              icon={
                                <i className="fa-solid fa-magnifying-glass pad-right-8"></i>
                              }
                              onClick={() => {
                                onSearch({
                                  page: 1,
                                  page_size,
                                  search_keyword,
                                  url,
                                  setRecords,
                                  setTotalRecords,
                                  setCurrentPage,
                                  setErrors,
                                  advance_search: { ...search_state },
                                });
                              }}
                            >
                              Search
                            </Button>
                          </Col>
                        </Row>
                      </Col>
                      <Col span={8}></Col>
                      <Col span={8}></Col>
                    </Row>
                  </div>
                </PageHeader>
              </Panel>
            </Collapse>
          </Col>
        </Row>
      )}

      <div
        style={{
          background: "#fff",
          padding: 24,
          borderBottomLeftRadius: 10,
          borderBottomRightRadius: 10,
        }}
      >
        <Row>
          <Col span={12}>
            <span className="module-title">{title}</span>
          </Col>
          {/* <Col span={12} className="has-text-right">
            <Button
              type="link"
              onClick={() => {
                navigate("/cashier");
              }}
            >
              Go Back Cashiering
            </Button>
          </Col> */}
        </Row>

        <Divider />
        {isEmpty(records) ? (
          <Form
            onFinish={() => {
              if (state.items.length <= 0) {
                return message.error(
                  "Unable to Save. Requires 1 or more item(s)"
                );
              }

              onSubmit({
                values: {
                  ...state,
                  items: state.items.filter((o) => !isEmpty(o.stock?._id)),
                },
                auth,
                url,
                setErrors,
                setState,
                date_fields,
                setLoading,
                setLoadingState,
              });
            }}
            initialValues={initialValues}
          >
            {state[transaction_counter.key] && (
              <Row>
                <Col span={12}>
                  <TextFieldGroup
                    label={transaction_counter.label}
                    value={state[transaction_counter.key]}
                    error={errors.remarks}
                    formItemLayout={smallFormItemLayout}
                    readOnly
                  />
                </Col>
              </Row>
            )}
            <Row>
              <Col span={12}>
                <DatePickerFieldGroup
                  label="Date"
                  name="date"
                  value={state.date || null}
                  onChange={(value) => {
                    onChange({
                      key: "date",
                      value: value,
                      setState,
                    });
                  }}
                  error={errors.date}
                  formItemLayout={smallFormItemLayout}
                />
              </Col>
            </Row>

            <Row>
              <Col span={12}>
                <TextFieldGroup
                  disabled={(state.items || [])?.length > 0}
                  label="PO#"
                  name="po_no"
                  value={state.purchase_order?.po_no || state.po_no}
                  error={errors.po_no}
                  onChange={(e) => {
                    onChange({
                      key: e.target.name,
                      value: e.target.value,
                      setState,
                    });
                  }}
                  formItemLayout={smallFormItemLayout}
                  help="Press enter to search for PO#"
                  onPressEnter={(e) => {
                    e.preventDefault();
                    if (!isEmpty(state.po_no)) {
                      axios
                        .post("/api/purchase-orders/po-no", {
                          po_no: state.po_no,
                        })
                        .then((response) => {
                          const record = { ...(response.data || {}) };

                          if (!isEmpty(record)) {
                            const {
                              project,
                              account,
                              items,
                              _id,
                              po_no,
                              cv_no,
                            } = record;

                            setState((prevState) => {
                              return {
                                ...prevState,
                                cv_no,
                                purchase_order: {
                                  _id,
                                  po_no,
                                },
                                project,
                                account,
                                items: items.map((o) => {
                                  const po_id = o._id;
                                  delete o._id;
                                  return {
                                    ...o,
                                    po_id,
                                  };
                                }),
                              };
                            });
                          } else {
                            message.error("No Purchase Order Found");
                            setState((prevState) => ({
                              ...prevState,
                              ...initialValues,
                              cv_no: "",
                            }));
                          }
                        })
                        .catch((err) => {
                          return message.error(
                            "There was an error processing your request"
                          );
                        });
                    }
                  }}
                />
              </Col>
            </Row>

            <Col span={12}>
              <SelectFieldGroup
                label="Supplier"
                disabled={true}
                value={state.account?.name}
                onFocus={() => {
                  onSupplierSearch({ value: "", setOptions });
                }}
                onSearch={(value) => onSupplierSearch({ value, setOptions })}
                onChange={(index) => {
                  const account = options.accounts?.[index] || null;
                  setState((prevState) => ({
                    ...prevState,
                    account,
                  }));
                }}
                formItemLayout={smallFormItemLayout}
                data={options.accounts}
                column="name"
                error={errors.account}
                onAddItem={() => accountFormModal.current.open()}
              />
            </Col>

            <Col span={12}>
              <SelectFieldGroup
                label="Warehouse"
                value={state.warehouse?.name}
                onFocus={() => {
                  onWarehouseSearch({ value: "", setOptions });
                }}
                onSearch={(value) => onWarehouseSearch({ value, setOptions })}
                onChange={(index) => {
                  const warehouse = options.warehouses?.[index] || null;
                  onChange({
                    key: "warehouse",
                    value: warehouse,
                    setState,
                  });
                }}
                formItemLayout={smallFormItemLayout}
                data={options.warehouses}
                column="name"
                error={errors.warehouse}
              />
            </Col>

            <TextFieldGroup
              label="Reference"
              name="reference"
              value={state.reference}
              error={errors.reference}
              onChange={(e) => {
                onChange({
                  key: e.target.name,
                  value: e.target.value,
                  setState,
                });
              }}
              formItemLayout={formItemLayout}
            />

            <TextAreaGroup
              label="Remarks"
              name="remarks"
              value={state.remarks}
              error={errors.remarks}
              onChange={(e) => {
                onChange({
                  key: e.target.name,
                  value: e.target.value,
                  setState,
                });
              }}
              formItemLayout={formItemLayout}
            />
            {state.status && state.status.datetime && (
              <TextFieldGroup
                label="Status"
                name="status"
                value={`${state.status.approval_status} / ${
                  state.status.user.name
                } / ${moment(state.status.datetime).format("LLL")}`}
                formItemLayout={formItemLayout}
                readOnly
              />
            )}
            {state.deleted && state.deleted.date && (
              <TextFieldGroup
                label="Voided By"
                name="status"
                value={`${state.deleted?.user?.name} / ${moment(
                  state.deleted.date
                ).format("LLL")}`}
                formItemLayout={formItemLayout}
                readOnly
              />
            )}

            <div className="m-t-1">
              <Table
                dataSource={addKeysToArray([
                  ...state.items,
                  {
                    footer: 1,
                    quantity: sumBy(state.items, (o) => round(o.quantity)),
                    case_quantity: sumBy(state.items, (o) =>
                      round(o.case_quantity)
                    ),
                    amount: sumBy(state.items, (o) => round(o.amount)),
                  },
                ])}
                columns={items_column}
                pagination={false}
                rowClassName={(record, index) => {
                  if (record.footer === 1) {
                    return "footer-summary has-text-weight-bold";
                  }
                }}
              />
            </div>

            <FormButtons
              state={state}
              auth={auth}
              loading={loading}
              url={url}
              initialValues={initialValues}
              initialItemValues={initialItemValues}
              setState={setState}
              setItem={setItem}
              onDelete={() => {
                onDelete({
                  id: state._id,
                  url,
                  user: auth.user,
                  setLoadingState,
                  cb: () => {
                    onSearch({
                      page: current_page,
                      page_size,
                      search_keyword,
                      url,
                      setRecords,
                      setTotalRecords,
                      setCurrentPage,
                      setErrors,
                      setLoadingState,
                      advance_search: { ...search_state },
                    });
                  },
                });
              }}
              onSearch={() => {
                onSearch({
                  page: current_page,
                  page_size,
                  search_keyword,
                  url,
                  setRecords,
                  setTotalRecords,
                  setCurrentPage,
                  setErrors,
                  setLoading,
                  setLoadingState,
                  advance_search: { ...search_state },
                });
              }}
              onClose={() => {
                onUpdateStatus({
                  url,
                  state,
                  approval_status: STATUS_CLOSED,
                  user: auth.user,
                  setLoadingState,
                  button_name: "APPROVE",
                  cb: () => {
                    edit({
                      record: state,
                      setState,
                      setErrors,
                      setRecords,
                      url,
                      date_fields,
                    });
                  },
                });
              }}
              has_print={!isEmpty(state._id)}
              has_cancel={!isEmpty(state._id)}
              onPrint={() =>
                window.open(`/print/${transaction}/${state._id}`, "_tab")
              }
              has_save={can_edit}
            />
          </Form>
        ) : (
          <Table
            dataSource={addKeysToArray(records)}
            columns={records_column}
            rowKey={(record) => record._id}
            onRow={(record, index) => {
              return {
                onDoubleClick: (e) => {
                  if (
                    hasAccess({
                      auth,
                      access: ACCESS_OPEN,
                      location,
                    })
                  ) {
                    edit({
                      record,
                      setState,
                      setErrors,
                      setRecords,
                      url,
                      date_fields,
                    });
                  }
                },
              };
            }}
            pagination={{
              current: current_page,
              defaultCurrent: current_page,
              onChange: (page, page_size) => {
                setPageSize(page_size);
                onSearch({
                  page,
                  page_size,
                  search_keyword,
                  url,
                  setRecords,
                  setTotalRecords,
                  setCurrentPage,
                  setErrors,
                  advance_search: { ...search_state },
                });
              },
              total: total_records,
              pageSize: page_size,
            }}
          />
        )}
      </div>
    </Content>
  );
}
